import React, { useState } from 'react';
import { ArrowRight, ChevronRight, Share2, RefreshCw, Star } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Quiz Component
const QuizApp = ({ isDesktop = false }) => {
  const [currentScreen, setCurrentScreen] = useState('start'); // 'start', 'quiz', 'result'
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [userAnswers, setUserAnswers] = useState([]);
  const [showConfetti, setShowConfetti] = useState(false);

  const quizData = {
    title: "RAMADAN MUBARAK",
    subtitle: "Test Your Knowledge",
    description: "Enter the lucky draw to win the prize by answering all 5 questions correctly",
    prize: "₹5000",
    sponsor: "Telkomsel",
    questions: [
      {
        id: 1,
        question: "What is the first prayer of the day called?",
        options: ["FAJR", "MAGHRIB"],
        correct: 0
      },
      {
        id: 2,
        question: "How many pillars of Islam are there?",
        options: ["Three", "Four"],
        correct: 2
      },
      {
        id: 3,
        question: "What is the holy book of Islam?",
        options: ["Torah", "Bible", ],
        correct: 2
      },
      {
        id: 4,
        question: "Which month is Ramadan in the Islamic calendar?",
        options: ["8th", "9th", ],
        correct: 1
      },
      {
        id: 5,
        question: "What is the pilgrimage to Mecca called?",
        options: ["Hajj", "Umrah", ],
        correct: 0
      }
    ]
  };

  const handleAnswerSelect = (answerIndex) => {
    setSelectedAnswer(answerIndex);
  };

  const handleSubmit = () => {
    if (selectedAnswer === null) return;

    const newAnswers = [...userAnswers, selectedAnswer];
    setUserAnswers(newAnswers);

    if (selectedAnswer === quizData.questions[currentQuestion].correct) {
      setScore(score + 1);
    }

    if (currentQuestion < quizData.questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      setSelectedAnswer(null);
    } else {
      setCurrentScreen('result');
      if (score + (selectedAnswer === quizData.questions[currentQuestion].correct ? 1 : 0) >= 4) {
        setShowConfetti(true);
        setTimeout(() => setShowConfetti(false), 3000);
      }
    }
  };

  const resetQuiz = () => {
    setCurrentScreen('start');
    setCurrentQuestion(0);
    setScore(0);
    setSelectedAnswer(null);
    setUserAnswers([]);
    setShowConfetti(false);
  };

  const shareResult = () => {
    if (navigator.share) {
      navigator.share({
        title: 'Ramadan Quiz Results',
        text: `I scored ${score}/${quizData.questions.length} in the Ramadan Quiz!`,
        url: window.location.href
      });
    } else {
      const text = `I scored ${score}/${quizData.questions.length} in the Ramadan Quiz! Check it out!`;
      navigator.clipboard.writeText(text);
      alert('Result copied to clipboard!');
    }
  };  

  const StartScreen = () => (
    <div className="font-serif bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 h-full flex flex-col relative overflow-hidden ">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-10 left-10 w-20 h-20 border-2 border-yellow-400 rounded-full"></div>
        <div className="absolute top-32 right-8 w-16 h-16 border-2 border-yellow-400 rounded-full"></div>
        <div className="absolute bottom-40 left-6 w-24 h-24 border-2 border-yellow-400 rounded-full"></div>
        <div className="absolute bottom-20 right-12 w-12 h-12 border-2 border-yellow-400 rounded-full"></div>
      </div>

      {/* Floating Lanterns */}
      <div className="absolute top-12 left-8 text-yellow-400 text-3xl animate-bounce">🏮</div>
      <div className="absolute top-24 right-12 text-yellow-400 text-2xl animate-bounce" style={{animationDelay: '0.5s'}}>🏮</div>
      <div className="absolute top-28 left-1/2 text-yellow-400 text-xl animate-bounce" style={{animationDelay: '1s'}}>🏮</div>

      <div className="flex-1 flex flex-col justify-center items-center px-6 relative z-10">
        <div className="text-center mb-2 mt-2">
          <h1 className={`text-white font-bold mb-1 tracking-wider ${isDesktop ? 'text-lg' : 'text-lg'}`}>
            {quizData.title}
          </h1>
          <p className={`text-blue-200 font-medium ${isDesktop ? 'text-sm' : 'text-sm'}`}>
            {quizData.subtitle}
          </p>
        </div>

        <div className={`bg-white rounded-2xl shadow-2xl p-3 w-full mb-2 ${isDesktop ? 'max-w-sm' : 'max-w-sm'}`}>
          <div className="text-center mb-1">
            <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-4 py-1 rounded-full text-sm font-medium mb-2">
              RAMADAN QUIZ
            </div>
            <p className={`text-gray-700 leading-relaxed mb-1 ${isDesktop ? 'text-sm' : 'text-sm'}`}>
              {quizData.description}
            </p>
            <div className="flex items-center justify-center space-x-1 mb-1">
              <span className={`text-red-500 font-bold ${isDesktop ? 'text-sm' : 'text-lg'}`}>{quizData.sponsor}</span>
              <span className={`text-green-600 font-bold ${isDesktop ? 'text-sm' : 'text-2xl'}`}>{quizData.prize}</span>
            </div>
          </div>

          {/* <button
            onClick={() => setCurrentScreen('quiz')}
            className={`w-full bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-white font-bold rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center space-x-2 ${isDesktop ? 'py-1 px-1 text-sm' : 'py-2 px-4'}`}
          >
            <span>Start Quiz</span>
            <ChevronRight size={isDesktop ? 24 : 20} />
          </button> */}
<button
  onClick={() => setCurrentScreen('quiz')}
  className={`relative z-10 w-full bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-white font-bold rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200 py-3 px-6 text-base flex items-center justify-center space-x-2`}
>
  <span className="pointer-events-none">Start Quiz</span>
  <ChevronRight size={isDesktop ? 24 : 20} />
</button>

          <div className="mt-2 text-center">
            <button className="text-blue-600 text-sm font-medium hover:underline">
              Share with friends
            </button>
            <p className="text-gray-500 text-xs mt-1">Share with your friends #RamadanQuiz</p>
          </div>
        </div>

        {/* Decorative Islamic Pattern */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 opacity-20">
          <div className={`border-4 border-yellow-400 rounded-full flex items-center justify-center ${isDesktop ? 'w-40 h-40' : 'w-32 h-32'}`}>
            <div className={`border-2 border-yellow-400 rounded-full flex items-center justify-center ${isDesktop ? 'w-24 h-24' : 'w-20 h-20'}`}>
              <div className={`bg-yellow-400 rounded-full ${isDesktop ? 'w-10 h-10' : 'w-8 h-8'}`}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const QuizScreen = () => (
    <div className=" font-serif bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 h-full flex flex-col relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-12 left-8 text-yellow-400 text-2xl animate-pulse">🏮</div>
      <div className="absolute top-16 right-12 text-yellow-400 text-xl animate-pulse" style={{animationDelay: '0.5s'}}>🏮</div>

      <div className="flex-1 flex flex-col justify-center items-center px-6 mt-2">
        <div className={`bg-white rounded-2xl shadow-2xl p-2 w-full ${isDesktop ? 'max-w-sm' : 'max-w-sm'}`}>
          <div className="text-center mb-1">
            <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-2 py-1 rounded-full text-sm font-medium mb-1">
              Question {currentQuestion + 1}
            </div>
            {/* <div className="text-right text-sm text-gray-500 mb-1">
              Score: {score} / {quizData.questions.length}
            </div> */}
          </div>

          <div className="mb-1">
            <h2 className={`text-gray-800 font-semibold mb-1 text-center leading-relaxed ${isDesktop ? 'text-sm' : 'text-sm'}`}>
              {quizData.questions[currentQuestion].question}
            </h2>
            
            <div className="space-y-1">
              {quizData.questions[currentQuestion].options.map((option, index) => (
                <button
                  key={index}
                  onClick={() => handleAnswerSelect(index)}
                  className={`w-full p-2 rounded-xl border-2 transition-all duration-200 text-left font-medium ${isDesktop ? 'text-sm' : 'text-sm'} ${
                    selectedAnswer === index
                      ? 'border-blue-500 bg-blue-50 text-blue-700'
                      : 'border-gray-200 hover:border-gray-300 bg-white text-gray-700'
                  }`}
                >
                  {option}
                </button>
              ))}
            </div>
          </div>

          <button
            onClick={handleSubmit}
            disabled={selectedAnswer === null}
            className={`w-full font-bold rounded-xl shadow-lg transform transition-all duration-200 ${isDesktop ? 'py-1 px-1 text-sm' : 'py-1 px-1'} ${
              selectedAnswer !== null
                ? 'bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-white '
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            SUBMIT
          </button>

          <div className="mt-1 text-center">
            <span className="text-red-500 font-bold text-sm">{quizData.sponsor}</span>
          </div>
        </div>

        {/* Progress Bar */}
        <div className={`w-full mt-1 ${isDesktop ? 'max-w-sm' : 'max-w-sm'}`}>
          <div className="bg-blue-900/50 rounded-full h-2 overflow-hidden">
            <div 
              className="bg-gradient-to-r from-yellow-400 to-yellow-500 h-2 rounded-full transition-all duration-500"
              style={{ width: `${((currentQuestion + 1) / quizData.questions.length) * 100}%` }}
            />
          </div>
          <p className="text-blue-200 text-sm text-center mt-1">
            Question {currentQuestion + 1} of {quizData.questions.length}
          </p>
        </div>
      </div>
    </div>
  );

  const ResultScreen = () => {
    const finalScore = score + (userAnswers[userAnswers.length - 1] === quizData.questions[quizData.questions.length - 1].correct ? 1 : 0);
    const isWinner = finalScore >= 4;
    
    return (
      <div className="font-serif bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 h-full flex flex-col relative overflow-hidden">
        {/* Confetti Effect */}
        {showConfetti && (
          <div className="absolute inset-0 pointer-events-none z-20">
            {[...Array(50)].map((_, i) => (
              <div
                key={i}
                className="absolute animate-ping"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 2}s`,
                  animationDuration: `${1 + Math.random() * 2}s`
                }}
              >
                {['🎉', '⭐', '🌟', '✨'][Math.floor(Math.random() * 4)]}
              </div>
            ))}
          </div>
        )}

        {/* Floating Lanterns */}
        <div className="absolute top-12 left-8 text-yellow-400 text-3xl animate-bounce">🏮</div>
        <div className="absolute top-16 right-12 text-yellow-400 text-2xl animate-bounce" style={{animationDelay: '0.5s'}}>🏮</div>

        <div className="flex-1 flex flex-col justify-center items-center px-6 relative z-10 mb-4">
          <div className={`bg-white rounded-2xl shadow-2xl p-2 mt-4 w-full h-80 ${isDesktop ? 'max-w-sm' : 'max-w-sm'}`}>
            <div className="text-center mb-1">
              <div className={` ${isDesktop ? 'text-2xl' : 'text-2xl'}`}>
                {isWinner ? '🏆' : '😊'}
              </div>
              <h2 className={`text-gray-800 font-bold  ${isDesktop ? 'text-lg' : 'text-lg'}`}>
                {isWinner ? 'Congratulations!' : 'Good Try!'}
              </h2>
              {/* <p className={`text-gray-600 mb-2 ${isDesktop ? 'text-base' : 'text-sm'}`}>
                Your Final Score
              </p> */}
              
              {/* <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-2xl py-1 px-1 mb-1">
                <div className={`font-bold ${isDesktop ? 'text-xl' : 'text-xl'}`}>{finalScore}/5</div>
                <div className="flex justify-center mt-1">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      size={isDesktop ? 18 : 20}
                      className={i < finalScore ? 'text-yellow-400 fill-current' : 'text-blue-300'}
                    />
                  ))}
                </div>
              </div> */}
<div className="bg-gradient-to-r from-[#36D1DC] to-[#5B86E5] text-white rounded-xl py-2 mb-4">
            <div className="text-2xl font-bold">{finalScore}/5</div>
            <div className="flex justify-center mt-1 space-x-1">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  size={20}
                  className={i < finalScore ? 'text-yellow-400 fill-current' : 'text-white/40'}
                />
              ))}
            </div>
          </div>
              {isWinner && (
                <div className="mb-2">
                  <p className={`text-green-600 font-semibold mb-1 ${isDesktop ? 'text-base' : 'text-sm'}`}>
                    🎉 You've won the lucky draw for {quizData.prize}!
                  </p>
                  <p className="text-gray-500 text-xs">
                    Winner will be announced on WhatsApp
                  </p>
                </div>
              )}
            </div>

            <div className="space-y-1">
              {/* <button
                onClick={shareResult}
                className={`w-full bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-white font-bold rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center space-x-2 ${isDesktop ? 'py-1 px-1 text-lg' : 'py-2 px-4'}`}
              >
                <Share2 size={isDesktop ? 20 : 18} />
                <span>Share Result</span>
              </button> */}

              <button
                onClick={resetQuiz}
                className={`w-full bg-white border-2 border-gray-300 hover:border-gray-400 text-gray-700 font-bold rounded-xl transition-all duration-200 flex items-center justify-center space-x-2 ${isDesktop ? 'py-3 px-6 text-lg' : 'py-2 px-4'}`}
              >
                <RefreshCw size={isDesktop ? 20 : 18} />
                <span>Play Again</span>
              </button>
            </div>

            <div className="mt-1 text-center">
              <span className="text-red-500 font-bold text-sm">{quizData.sponsor}</span>
            </div>
          </div>
        </div>

        {/* Decorative Pattern */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 opacity-20">
          <div className={`border-4 border-yellow-400 rounded-full flex items-center justify-center ${isDesktop ? 'w-40 h-40' : 'w-32 h-32'}`}>
            <div className={`border-2 border-yellow-400 rounded-full flex items-center justify-center ${isDesktop ? 'w-24 h-24' : 'w-20 h-20'}`}>
              <div className={`bg-yellow-400 rounded-full ${isDesktop ? 'w-10 h-10' : 'w-8 h-8'}`}></div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="w-full h-full font-serif">
      {currentScreen === 'start' && <StartScreen />}
      {currentScreen === 'quiz' && <QuizScreen />}
      {currentScreen === 'result' && <ResultScreen />}
    </div>
  );
};

function App() {
  const [isMobile, setIsMobile] = useState(true);

  return (
    <>

      <Helmet>
       <title>
       Ramadan Mubarak Campaign | Quiz Ad Showcase by Bidbox
        </title>
        <meta
          name="description"
          content="Discover how Ramadan Mubarak campaigns run in Quiz ads with Bidbox. Explore engaging ad creatives that connect audiences during the festive season."
        />
        {/* <meta
          name="keywords"
          content="Discover how Recard campaigns run in CTV Quiz ads. Explore Bidbox’s creative retargeting strategies that boost engagement & conversions."
        /> */}
         <link
          rel="canonical"
          href="https://bidbox.ai/quiz/ramadan"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
    </Helmet>
    <div className="min-h-screen bg-gray-50 mt-10">
      <div className="container mx-auto px-8 py-8 lg:py-12">
        <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
          {/* Left column - Content */}
          <div className="flex-1 lg:max-w-lg">
            {/* Header */}
            <header className="animate-slide-up">
              {/* Title and tag */}
              <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                  Quiz: Play. Learn. Win.
                  </h1>
                  <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                  Quiz

                  </span>
                </div>
              </div>
            </header>

            {/* Content Section */}
            <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
              {/* Make it yours section */}
              <div className="mb-8">
                <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
                BOOST USER ENGAGEMENT
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
                This interactive quiz lets users test their knowledge while engaging with your brand. Whether it’s to educate, entertain, or reward, each question pulls them deeper, offering progress tracking, sleek UI, and prizes at the finish line. Just add your content and branding to launch a fun, high-impact experience that sticks.
                </p>
                
                {/* CTA Button */}
                <Link to='/contact'>
                <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                  <span>Start with this Template</span>
                  <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                </button>
         </Link>
              </div>
            </div>
          </div>

          {/* Right column - Template Preview */}
          <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
            {/* Preview toggle */}
            <div className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4" style={{ animationDelay: '0.3s' }}>
                <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
                  <div className="flex items-center space-x-4">
                    {/* <span className="text-sm text-gray-600 font-medium">Preview in:</span> */}
                    <div className="flex items-center space-x-3">
                      <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                        Mobile
                      </span>
                      <button
                        onClick={() => setIsMobile(!isMobile)}
                        className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                      >
                        <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
                      </button>
                      <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                        Desktop
                      </span>
                    </div>
                  </div>
                </div>
              </div>
           
            <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
              
              {/* Mobile Mockup */}
              {isMobile && (
                <div className="mx-auto max-w-xs">
                  {/* iPhone mockup */}
                  <div className="relative bg-gray-200 rounded-[2.5rem] p-2 shadow-2xl">
                    {/* Status bar area */}
                    <div className="bg-white rounded-[2rem] overflow-hidden">
                      {/* Status bar */}
                      <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
                        <span>9:41</span>
                        <div className="flex items-center space-x-1">
                          <div className="flex space-x-1">
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                          </div>
                          <div className="w-6 h-3 border border-black rounded-sm relative">
                            <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                          </div>
                        </div>
                      </div>

                      {/* Browser bar */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
                        <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
                          ramadan-quiz.com
                        </div>
                      </div>

                      {/* Content area */}
                      <div className= "p-4 bg-gray-50 h-[400px] overflow-y-auto hide-scrollbar ">
                        {/* Quiz - Full screen on mobile */}
                        <div className="space-y-3">
                    <div className="h-3 bg-gray-200 rounded w-full"></div>
                    <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                    <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                  </div>
                  
                        <div className="mb-6">
                        <div className="relative group transform transition-all duration-300 rounded-lg overflow-hidden">

                          <QuizApp isDesktop={false} />
                        </div>
                        </div>
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Desktop Mockup */}
              {!isMobile && (
                <div className="w-full max-w-4xl mx-auto hidden lg:block">
                  {/* Desktop Screen Frame */}
                  <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
                    {/* Screen */}
                    <div className="bg-white rounded-lg overflow-hidden shadow-inner" style={{ aspectRatio: '16/10' }}>
                      {/* macOS-style window header */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center border-b border-gray-200">
                        <div className="flex space-x-2">
                          <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                        </div>
                        <div className="flex-1 mx-2">
                          <div className="bg-white rounded-md px-2 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
                            🔒 ramadan-quiz.com
                          </div>
                        </div>
                        <div className="flex space-x-2">
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                        </div>
                      </div>

                      {/* Browser content area */}
                      <div className="p-2 bg-gray-50 h-[500px] overflow-y-auto hide-scrollbar">
                        {/* Quiz centered on desktop */}
                        <div className="mb-2">
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>

                          </div>
                        <div className="flex justify-center ">
                          <div className="w-full max-w-md ">
                            <QuizApp isDesktop={true} />
                          </div>
                        </div>
                        <div className="grid grid-cols-2 gap-6 mb-6 mt-2">
                            <div className="space-y-3">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                            <div className="space-y-3 mt-2">
                              <div className="h-4 bg-gray-200 rounded w-full"></div>
                              <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                              <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                            </div>
                          </div>

                          {/* Sidebar placeholders */}
                          <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                          </div>
                          <div className="grid grid-cols-2 gap-6 mb-6">
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>

                        {/* Sidebar placeholders */}
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Monitor stand */}
                  <div className="flex justify-center">
                    <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
                  </div>
                  <div className="flex justify-center">
                    <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes slide-up {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-slide-up {
          animation: slide-up 0.8s ease-out;
        }
        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }
      `}</style>
    </div>
    <div className="max-w-7xl mx-auto px-4 py-10">
          <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
    
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {/* Card 1 */}
            <Link to="/scratch-to-win/hm" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
              <img
                src="/assets/sc.avif"
                alt="Card 1"
                className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h2 className="text-lg font-semibold">Scratch TO Win</h2>
              </div>
            </Link>
    
            {/* Card 2 */}
            <Link to="/swipe-to-reveal/pizza" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
              <img
                src="/assets/sw.jpg"
                alt="Card 2"
                className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h2 className="text-lg font-semibold">Swipe to Reveal</h2>
              </div>
            </Link>
    
            {/* Card 3 */}
            <Link to="/tap-to-reveal/thumsup" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
              <img
                src="/assets/tmmm.png"
                alt="Card 3"
                className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h2 className="text-lg font-semibold">Tap to Reveal</h2>
              </div>
            </Link>
    
            {/* Card 4 */}
            <Link to="/interactive-selector/travel-ramadan" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
              <img
                src="/assets/du.jpg"
                alt="Card 4"
                className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                <h2 className="text-lg font-semibold">Dubai Travel</h2>
              </div>
            </Link>
    
           
          </div>
        </div>
    </>
  );
}

export default App;
// import React, { useState, useRef, useEffect } from 'react';
// import { ChevronLeft, ChevronRight, Copy, Play, Pause, Maximize2, Download, Share2, Eye, Settings, Monitor, Smartphone, Gift, Sparkles, Zap, Target, RotateCcw, RefreshCw, Star } from 'lucide-react';

// // Quiz Component
// const QuizApp = ({ isDesktop = false }) => {
//   const [currentScreen, setCurrentScreen] = useState('start'); // 'start', 'quiz', 'result'
//   const [currentQuestion, setCurrentQuestion] = useState(0);
//   const [score, setScore] = useState(0);
//   const [selectedAnswer, setSelectedAnswer] = useState(null);
//   const [userAnswers, setUserAnswers] = useState([]);
//   const [showConfetti, setShowConfetti] = useState(false);

//   const quizData = {
//     title: "RAMADAN MUBARAK",
//     subtitle: "Test Your Knowledge",
//     description: "Enter the lucky draw to win the prize by answering all 5 questions correctly",
//     prize: "₹5000",
//     sponsor: "Telkomsel",
//     questions: [
//       {
//         id: 1,
//         question: "What is the first prayer of the day called?",
//         options: ["FAJR", "MAGHRIB", "DHUHR", "ASAR"],
//         correct: 0
//       },
//       {
//         id: 2,
//         question: "How many pillars of Islam are there?",
//         options: ["Three", "Four", "Five", "Six"],
//         correct: 2
//       },
//       {
//         id: 3,
//         question: "What is the holy book of Islam?",
//         options: ["Torah", "Bible", "Quran", "Vedas"],
//         correct: 2
//       },
//       {
//         id: 4,
//         question: "Which month is Ramadan in the Islamic calendar?",
//         options: ["8th", "9th", "10th", "11th"],
//         correct: 1
//       },
//       {
//         id: 5,
//         question: "What is the pilgrimage to Mecca called?",
//         options: ["Hajj", "Umrah", "Zakat", "Sawm"],
//         correct: 0
//       }
//     ]
//   };

//   const handleAnswerSelect = (answerIndex) => {
//     setSelectedAnswer(answerIndex);
//   };

//   const handleSubmit = () => {
//     if (selectedAnswer === null) return;

//     const newAnswers = [...userAnswers, selectedAnswer];
//     setUserAnswers(newAnswers);

//     if (selectedAnswer === quizData.questions[currentQuestion].correct) {
//       setScore(score + 1);
//     }

//     if (currentQuestion < quizData.questions.length - 1) {
//       setCurrentQuestion(currentQuestion + 1);
//       setSelectedAnswer(null);
//     } else {
//       setCurrentScreen('result');
//       if (score + (selectedAnswer === quizData.questions[currentQuestion].correct ? 1 : 0) >= 4) {
//         setShowConfetti(true);
//         setTimeout(() => setShowConfetti(false), 3000);
//       }
//     }
//   };

//   const resetQuiz = () => {
//     setCurrentScreen('start');
//     setCurrentQuestion(0);
//     setScore(0);
//     setSelectedAnswer(null);
//     setUserAnswers([]);
//     setShowConfetti(false);
//   };

//   const shareResult = () => {
//     if (navigator.share) {
//       navigator.share({
//         title: 'Ramadan Quiz Results',
//         text: `I scored ${score}/${quizData.questions.length} in the Ramadan Quiz!`,
//         url: window.location.href
//       });
//     } else {
//       const text = `I scored ${score}/${quizData.questions.length} in the Ramadan Quiz! Check it out!`;
//       navigator.clipboard.writeText(text);
//       alert('Result copied to clipboard!');
//     }
//   };

//   const StartScreen = () => (
//     <div className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 h-full flex flex-col relative overflow-hidden">
//       {/* Background Pattern */}
//       <div className="absolute inset-0 opacity-20">
//         <div className="absolute top-10 left-10 w-20 h-20 border-2 border-yellow-400 rounded-full"></div>
//         <div className="absolute top-32 right-8 w-16 h-16 border-2 border-yellow-400 rounded-full"></div>
//         <div className="absolute bottom-40 left-6 w-24 h-24 border-2 border-yellow-400 rounded-full"></div>
//         <div className="absolute bottom-20 right-12 w-12 h-12 border-2 border-yellow-400 rounded-full"></div>
//       </div>

//       {/* Floating Lanterns */}
//       <div className="absolute top-12 left-8 text-yellow-400 text-3xl animate-bounce">🏮</div>
//       <div className="absolute top-16 right-12 text-yellow-400 text-2xl animate-bounce" style={{animationDelay: '0.5s'}}>🏮</div>
//       <div className="absolute top-24 left-1/2 text-yellow-400 text-xl animate-bounce" style={{animationDelay: '1s'}}>🏮</div>

//       <div className="flex-1 flex flex-col justify-center items-center px-6 relative z-10">
//         <div className="text-center mb-8">
//           <h1 className={`text-white font-bold mb-2 tracking-wider ${isDesktop ? 'text-5xl' : 'text-4xl'}`}>
//             {quizData.title}
//           </h1>
//           <p className={`text-blue-200 font-medium ${isDesktop ? 'text-xl' : 'text-lg'}`}>
//             {quizData.subtitle}
//           </p>
//         </div>

//         <div className={`bg-white rounded-2xl shadow-2xl p-6 w-full mb-8 ${isDesktop ? 'max-w-lg' : 'max-w-sm'}`}>
//           <div className="text-center mb-6">
//             <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-4 py-2 rounded-full text-sm font-medium mb-4">
//               RAMADAN QUIZ
//             </div>
//             <p className={`text-gray-700 leading-relaxed mb-4 ${isDesktop ? 'text-base' : 'text-sm'}`}>
//               {quizData.description}
//             </p>
//             <div className="flex items-center justify-center space-x-2 mb-4">
//               <span className={`text-red-500 font-bold ${isDesktop ? 'text-xl' : 'text-lg'}`}>{quizData.sponsor}</span>
//               <span className={`text-green-600 font-bold ${isDesktop ? 'text-3xl' : 'text-2xl'}`}>{quizData.prize}</span>
//             </div>
//           </div>

//           <button
//             onClick={() => setCurrentScreen('quiz')}
//             className={`w-full bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-white font-bold rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center space-x-2 ${isDesktop ? 'py-4 px-8 text-lg' : 'py-3 px-6'}`}
//           >
//             <span>Start Quiz</span>
//             <ChevronRight size={isDesktop ? 24 : 20} />
//           </button>

//           <div className="mt-4 text-center">
//             <button className="text-blue-600 text-sm font-medium hover:underline">
//               Share with friends
//             </button>
//             <p className="text-gray-500 text-xs mt-1">Share with your friends #RamadanQuiz</p>
//           </div>
//         </div>

//         {/* Decorative Islamic Pattern */}
//         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 opacity-20">
//           <div className={`border-4 border-yellow-400 rounded-full flex items-center justify-center ${isDesktop ? 'w-40 h-40' : 'w-32 h-32'}`}>
//             <div className={`border-2 border-yellow-400 rounded-full flex items-center justify-center ${isDesktop ? 'w-24 h-24' : 'w-20 h-20'}`}>
//               <div className={`bg-yellow-400 rounded-full ${isDesktop ? 'w-10 h-10' : 'w-8 h-8'}`}></div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const QuizScreen = () => (
//     <div className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 h-full flex flex-col relative overflow-hidden">
//       {/* Decorative Elements */}
//       <div className="absolute top-12 left-8 text-yellow-400 text-2xl animate-pulse">🏮</div>
//       <div className="absolute top-16 right-12 text-yellow-400 text-xl animate-pulse" style={{animationDelay: '0.5s'}}>🏮</div>

//       <div className="flex-1 flex flex-col justify-center items-center px-6">
//         <div className={`bg-white rounded-2xl shadow-2xl p-6 w-full ${isDesktop ? 'max-w-lg' : 'max-w-sm'}`}>
//           <div className="text-center mb-4">
//             <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-4 py-2 rounded-full text-sm font-medium mb-2">
//               Question {currentQuestion + 1}
//             </div>
//             <div className="text-right text-sm text-gray-500 mb-4">
//               Score: {score} / {quizData.questions.length}
//             </div>
//           </div>

//           <div className="mb-6">
//             <h2 className={`text-gray-800 font-semibold mb-4 text-center leading-relaxed ${isDesktop ? 'text-xl' : 'text-lg'}`}>
//               {quizData.questions[currentQuestion].question}
//             </h2>
            
//             <div className="space-y-3">
//               {quizData.questions[currentQuestion].options.map((option, index) => (
//                 <button
//                   key={index}
//                   onClick={() => handleAnswerSelect(index)}
//                   className={`w-full p-4 rounded-xl border-2 transition-all duration-200 text-left font-medium ${isDesktop ? 'text-base' : 'text-sm'} ${
//                     selectedAnswer === index
//                       ? 'border-blue-500 bg-blue-50 text-blue-700'
//                       : 'border-gray-200 hover:border-gray-300 bg-white text-gray-700'
//                   }`}
//                 >
//                   {option}
//                 </button>
//               ))}
//             </div>
//           </div>

//           <button
//             onClick={handleSubmit}
//             disabled={selectedAnswer === null}
//             className={`w-full font-bold rounded-xl shadow-lg transform transition-all duration-200 ${isDesktop ? 'py-3 px-6 text-lg' : 'py-2 px-4'} ${
//               selectedAnswer !== null
//                 ? 'bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-white hover:scale-105'
//                 : 'bg-gray-300 text-gray-500 cursor-not-allowed'
//             }`}
//           >
//             SUBMIT
//           </button>

//           <div className="mt-4 text-center">
//             <span className="text-red-500 font-bold text-sm">{quizData.sponsor}</span>
//           </div>
//         </div>

//         {/* Progress Bar */}
//         <div className={`w-full mt-6 ${isDesktop ? 'max-w-lg' : 'max-w-sm'}`}>
//           <div className="bg-blue-900/50 rounded-full h-2 overflow-hidden">
//             <div 
//               className="bg-gradient-to-r from-yellow-400 to-yellow-500 h-2 rounded-full transition-all duration-500"
//               style={{ width: `${((currentQuestion + 1) / quizData.questions.length) * 100}%` }}
//             />
//           </div>
//           <p className="text-blue-200 text-sm text-center mt-2">
//             Question {currentQuestion + 1} of {quizData.questions.length}
//           </p>
//         </div>
//       </div>
//     </div>
//   );

//   const ResultScreen = () => {
//     const finalScore = score + (userAnswers[userAnswers.length - 1] === quizData.questions[quizData.questions.length - 1].correct ? 1 : 0);
//     const isWinner = finalScore >= 4;
    
//     return (
//       <div className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 h-full flex flex-col relative overflow-hidden">
//         {/* Confetti Effect */}
//         {showConfetti && (
//           <div className="absolute inset-0 pointer-events-none z-20">
//             {[...Array(50)].map((_, i) => (
//               <div
//                 key={i}
//                 className="absolute animate-ping"
//                 style={{
//                   left: `${Math.random() * 100}%`,
//                   top: `${Math.random() * 100}%`,
//                   animationDelay: `${Math.random() * 2}s`,
//                   animationDuration: `${1 + Math.random() * 2}s`
//                 }}
//               >
//                 {['🎉', '⭐', '🌟', '✨'][Math.floor(Math.random() * 4)]}
//               </div>
//             ))}
//           </div>
//         )}

//         {/* Floating Lanterns */}
//         <div className="absolute top-12 left-8 text-yellow-400 text-3xl animate-bounce">🏮</div>
//         <div className="absolute top-16 right-12 text-yellow-400 text-2xl animate-bounce" style={{animationDelay: '0.5s'}}>🏮</div>

//         <div className="flex-1 flex flex-col justify-center items-center px-6 relative z-10">
//           <div className={`bg-white rounded-2xl shadow-2xl p-6 w-full ${isDesktop ? 'max-w-lg' : 'max-w-sm'}`}>
//             <div className="text-center mb-6">
//               <div className={`mb-4 ${isDesktop ? 'text-5xl' : 'text-4xl'}`}>
//                 {isWinner ? '🏆' : '😊'}
//               </div>
//               <h2 className={`text-gray-800 font-bold mb-2 ${isDesktop ? 'text-3xl' : 'text-2xl'}`}>
//                 {isWinner ? 'Congratulations!' : 'Good Try!'}
//               </h2>
//               <p className={`text-gray-600 mb-4 ${isDesktop ? 'text-base' : 'text-sm'}`}>
//                 Your Final Score
//               </p>
              
//               <div className="bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-2xl py-6 px-6 mb-6">
//                 <div className={`font-bold ${isDesktop ? 'text-4xl' : 'text-3xl'}`}>{finalScore}/5</div>
//                 <div className="flex justify-center mt-3">
//                   {[...Array(5)].map((_, i) => (
//                     <Star
//                       key={i}
//                       size={isDesktop ? 28 : 20}
//                       className={i < finalScore ? 'text-yellow-400 fill-current' : 'text-blue-300'}
//                     />
//                   ))}
//                 </div>
//               </div>

//               {isWinner && (
//                 <div className="mb-6">
//                   <p className={`text-green-600 font-semibold mb-2 ${isDesktop ? 'text-base' : 'text-sm'}`}>
//                     🎉 You've won the lucky draw for {quizData.prize}!
//                   </p>
//                   <p className="text-gray-500 text-xs">
//                     Winner will be announced on WhatsApp
//                   </p>
//                 </div>
//               )}
//             </div>

//             <div className="space-y-3">
//               <button
//                 onClick={shareResult}
//                 className={`w-full bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-white font-bold rounded-xl shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center space-x-2 ${isDesktop ? 'py-3 px-6 text-lg' : 'py-2 px-4'}`}
//               >
//                 <Share2 size={isDesktop ? 20 : 18} />
//                 <span>Share Result</span>
//               </button>

//               <button
//                 onClick={resetQuiz}
//                 className={`w-full bg-white border-2 border-gray-300 hover:border-gray-400 text-gray-700 font-bold rounded-xl transition-all duration-200 flex items-center justify-center space-x-2 ${isDesktop ? 'py-3 px-6 text-lg' : 'py-2 px-4'}`}
//               >
//                 <RefreshCw size={isDesktop ? 20 : 18} />
//                 <span>Play Again</span>
//               </button>
//             </div>

//             <div className="mt-4 text-center">
//               <span className="text-red-500 font-bold text-sm">{quizData.sponsor}</span>
//             </div>
//           </div>
//         </div>

//         {/* Decorative Pattern */}
//         <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 opacity-20">
//           <div className={`border-4 border-yellow-400 rounded-full flex items-center justify-center ${isDesktop ? 'w-40 h-40' : 'w-32 h-32'}`}>
//             <div className={`border-2 border-yellow-400 rounded-full flex items-center justify-center ${isDesktop ? 'w-24 h-24' : 'w-20 h-20'}`}>
//               <div className={`bg-yellow-400 rounded-full ${isDesktop ? 'w-10 h-10' : 'w-8 h-8'}`}></div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="w-full h-full">
//       {currentScreen === 'start' && <StartScreen />}
//       {currentScreen === 'quiz' && <QuizScreen />}
//       {currentScreen === 'result' && <ResultScreen />}
//     </div>
//   );
// };

// export default function QuizCampaignMockup() {
//     const [selectedDevice, setSelectedDevice] = useState('Mobile');
//     const [isPlaying, setIsPlaying] = useState(false);

//     return (
//         <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-4 lg:p-6">
//             {/* Header */}
//             <div className="mb-6 lg:mb-8">
//                 <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
//                     <div>
//                         <h1 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">Ramadan Quiz Campaign</h1>
//                         <p className="text-gray-600 text-sm lg:text-base">Interactive quiz with knowledge testing and rewards</p>
//                     </div>
//                     <div className="flex items-center gap-3">
//                         <button className="px-3 py-2 lg:px-4 lg:py-2 bg-white rounded-lg shadow-sm border border-gray-200 hover:bg-gray-50 transition-colors flex items-center gap-2 text-sm lg:text-base">
//                             <Settings className="h-4 w-4" />
//                             Settings
//                         </button>
//                         <button className="px-3 py-2 lg:px-4 lg:py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2 text-sm lg:text-base">
//                             <Share2 className="h-4 w-4" />
//                             Share
//                         </button>
//                     </div>
//                 </div>
//             </div>

//             <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 lg:gap-6">
//                 {/* Left Sidebar - Project Info */}
//                 <div className="lg:col-span-1 order-2 lg:order-1">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:p-6 mb-4 lg:mb-6">
//                         <div className="flex items-center gap-3 mb-4">
//                             <div className="w-10 h-10 lg:w-12 lg:h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center">
//                                 <Sparkles className="h-5 w-5 lg:h-6 lg:w-6 text-white" />
//                             </div>
//                             <div>
//                                 <h2 className="text-base lg:text-lg font-semibold text-gray-900">Quiz Campaign</h2>
//                                 <p className="text-xs lg:text-sm text-gray-500">ID: QZ-2024-001</p>
//                             </div>
//                         </div>
                        
//                         <div className="space-y-3">
//                             <div className="flex justify-between items-center">
//                                 <span className="text-xs lg:text-sm text-gray-600">Status</span>
//                                 <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs font-medium">Active</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-xs lg:text-sm text-gray-600">Campaign</span>
//                                 <span className="text-xs lg:text-sm text-gray-900">Ramadan 2024</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-xs lg:text-sm text-gray-600">Questions</span>
//                                 <span className="text-xs lg:text-sm text-gray-900">5 Total</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-xs lg:text-sm text-gray-600">Prize</span>
//                                 <span className="text-xs lg:text-sm text-green-600 font-semibold">₹5000</span>
//                             </div>
//                         </div>

//                         <button className="w-full mt-4 text-blue-600 hover:text-blue-700 text-xs lg:text-sm font-medium">
//                             View Quiz Analytics
//                         </button>
//                     </div>

//                     {/* Quick Actions */}
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:p-6">
//                         <h3 className="text-base lg:text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
//                         <div className="space-y-3">
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-xs lg:text-sm transition-colors flex items-center gap-2">
//                                 <Download className="h-4 w-4" />
//                                 Export Quiz
//                             </button>
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-xs lg:text-sm transition-colors flex items-center gap-2">
//                                 <Copy className="h-4 w-4" />
//                                 Copy Embed Code
//                             </button>
//                             <button className="w-full px-4 py-2 bg-gray-50 hover:bg-gray-100 rounded-lg text-left text-xs lg:text-sm transition-colors flex items-center gap-2">
//                                 <Eye className="h-4 w-4" />
//                                 Preview Results
//                             </button>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Center Content - Preview Area */}
//                 <div className="lg:col-span-2 order-1 lg:order-2">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:p-6">
//                         {/* Device Toggle */}
//                         <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
//                             <div className="flex items-center gap-2">
//                                 <h3 className="text-base lg:text-lg font-semibold text-gray-900">Interactive Quiz Preview</h3>
//                                 <Copy className="h-4 w-4 text-gray-400 cursor-pointer hover:text-gray-600 transition-colors" />
//                             </div>
//                             <div className="flex items-center bg-gray-100 rounded-lg p-1">
//                                 {[
//                                     { name: 'Mobile', icon: Smartphone },
//                                     { name: 'Desktop', icon: Monitor }
//                                 ].map(({ name, icon: Icon }) => (
//                                     <button
//                                         key={name}
//                                         className={`px-2 py-1 lg:px-3 lg:py-2 rounded-md text-xs lg:text-sm font-medium transition-all flex items-center gap-1 lg:gap-2 ${
//                                             selectedDevice === name
//                                                 ? 'bg-white text-blue-600 shadow-sm'
//                                                 : 'text-gray-600 hover:text-gray-900'
//                                         }`}
//                                         onClick={() => setSelectedDevice(name)}
//                                     >
//                                         <Icon className="h-3 w-3 lg:h-4 lg:w-4" />
//                                         {name}
//                                     </button>
//                                 ))}
//                             </div>
//                         </div>

//                         {/* Navigation */}
//                         <div className="flex items-center justify-between mb-6">
//                             <button className="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors text-sm">
//                                 <ChevronLeft className="h-4 w-4" />
//                                 Previous Quiz
//                             </button>
//                             <div className="flex items-center gap-2">
//                                 <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
//                                 <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
//                                 <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
//                             </div>
//                             <button className="flex items-center gap-2 text-gray-500 hover:text-gray-700 transition-colors text-sm">
//                                 Next Quiz
//                                 <ChevronRight className="h-4 w-4" />
//                             </button>
//                         </div>

//                         {/* Preview Container */}
//                         <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-4 lg:p-8 min-h-[400px] lg:min-h-[600px] flex items-center justify-center">
//                             {/* Device Frame */}
//                             <div className="relative">
//                                 {selectedDevice === 'Mobile' ? (
//                                     <div className="relative">
//                                         <div className="absolute -inset-4 bg-gradient-to-r from-blue-500/20 to-indigo-500/20 rounded-3xl blur-xl"></div>
//                                         <div className="relative bg-gray-900 rounded-3xl p-2 shadow-2xl">
//                                             <div className="bg-black rounded-2xl overflow-hidden">
//                                                 <div className="w-[280px] h-[500px] lg:w-[300px] lg:h-[560px] relative">
//                                                     <QuizApp isDesktop={false} />
//                                                 </div>
//                                             </div>
//                                             <div className="w-16 h-1 lg:w-20 lg:h-1 bg-gray-600 rounded-full mx-auto mt-2"></div>
//                                         </div>
//                                     </div>
//                                 ) : (
//                                     <div className="relative">
//                                         <div className="absolute -inset-4 bg-gradient-to-r from-blue-500/20 to-indigo-500/20 rounded-xl blur-xl"></div>
//                                         <div className="relative bg-white rounded-xl shadow-2xl p-4">
//                                             <div className="bg-gray-100 rounded-lg p-2">
//                                                 <div className="w-[320px] h-[600px] lg:w-[500px] lg:h-[700px] bg-black rounded overflow-hidden relative">
//                                                     <QuizApp isDesktop={true} />
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                                   {/* Interaction Guide */}
//                                   <div className="mt-6 bg-blue-50 rounded-lg p-4">
//                             <div className="flex items-center gap-3">
//                                 <div className="w-6 h-6 lg:w-8 lg:h-8 bg-blue-600 text-white rounded-full flex items-center justify-center">
//                                     <span className="text-sm">✈️</span>
//                                 </div>
//                                 <div>
//                                     <h4 className="font-semibold text-blue-900 text-sm lg:text-base">Interactive Travel Flow</h4>
//                                     <p className="text-xs lg:text-sm text-blue-700">Click on destination cards to explore offers and book your perfect Eid getaway</p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Right Sidebar - Details */}
//                 <div className="lg:col-span-1 order-3">
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 lg:p-6 mb-4 lg:mb-6">
//                         <h3 className="text-base lg:text-lg font-semibold text-gray-900 mb-4">Creative Details</h3>
                        
//                         <div className="space-y-3 lg:space-y-4">
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-xs lg:text-sm text-gray-600 mb-1">Dimensions</div>
//                                 <div className="text-base lg:text-lg font-semibold text-gray-900">320 × 600px</div>
//                             </div>
                            
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-xs lg:text-sm text-gray-600 mb-1">Format</div>
//                                 <div className="text-base lg:text-lg font-semibold text-gray-900">Interactive HTML5</div>
//                             </div>
                            
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-xs lg:text-sm text-gray-600 mb-1">Interaction</div>
//                                 <div className="text-base lg:text-lg font-semibold text-gray-900">Multi-Step Flow</div>
//                             </div>
                            
//                             <div className="bg-gray-50 rounded-lg p-3">
//                                 <div className="text-xs lg:text-sm text-gray-600 mb-1">File Size</div>
//                                 <div className="text-base lg:text-lg font-semibold text-gray-900">3.2 MB</div>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Performance Metrics */}
//                     <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
//                         <h3 className="text-lg font-semibold text-gray-900 mb-4">Engagement Stats</h3>
//                         <div className="space-y-3">
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Selection Rate</span>
//                                 <span className="text-sm font-semibold text-green-600">12.4%</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Flow Completion</span>
//                                 <span className="text-sm font-semibold text-blue-600">8.7%</span>
//                             </div>
//                             <div className="flex justify-between items-center">
//                                 <span className="text-sm text-gray-600">Booking Rate</span>
//                                 <span className="text-sm font-semibold text-purple-600">5.2%</span>
//                             </div>
//                         </div>
//                     </div>

                   

                   
                   
//                 </div>
//             </div>
//         </div>
//     );
// }






